const API_BASE_URL = process.env.REACT_APP_API_URL;

// Remove the /api prefix since it's already in the environment variable
export const API_URLS = {
    companies: `${API_BASE_URL}/api/companies`,
    getCompany: (id) => `${API_BASE_URL}/api/companies/${id}`,
    updateCompany: (id) => `${API_BASE_URL}/api/companies/${id}`,
    deleteCompany: (id) => `${API_BASE_URL}/api/companies/${id}`,
    jobSeekers: `${API_BASE_URL}/api/job-seekers`,
    getJobSeeker: (id) => `${API_BASE_URL}/api/job-seekers/${id}`,
    updateJobSeeker: (id) => `${API_BASE_URL}/api/job-seekers/${id}`,
    deleteJobSeeker: (id) => `${API_BASE_URL}/api/job-seekers/${id}`,
    jobs: `${API_BASE_URL}/api/jobs`,
    getJob: (id) => `${API_BASE_URL}/api/jobs/${id}`,
    updateJob: (id) => `${API_BASE_URL}/api/jobs/${id}`,
    deleteJob: (id) => `${API_BASE_URL}/api/jobs/${id}`,
    login: `${API_BASE_URL}/api/auth/login`,
    logout: `${API_BASE_URL}/api/auth/logout`,
    skills: `${API_BASE_URL}/api/skills`,
    getSkill: (id) => `${API_BASE_URL}/api/skills/${id}`,
    updateSkill: (id) => `${API_BASE_URL}/api/skills/${id}`,
    deleteSkill: (id) => `${API_BASE_URL}/api/skills/${id}`
};